<template>
  <div>
    <van-nav-bar title="策略详情" fixed="fixed">
      <template #left>
        <div @click="$back(this)" class="backButton">
          <svg-icon icon-class="backButton" style="width:12px;height:20px;"></svg-icon>
        </div>
      </template>
      <template #right>
        <div @click="$store.state.shareShow = true">
          <svg-icon icon-class="detailShare" style="width:20px;height:18px;"></svg-icon>
        </div>
      </template>

    </van-nav-bar>

    <share></share>


    <div style="padding-top: 46px;">


      <transition name="fade" appear>


        <div class="background">
          <div class="mainBody">
            <div class="inBody">

              <div class="strategyInfo" v-if="stDRes.data.release_time_check">
                <div class="authorLabel">来自</div>
                <div class="authorD">{{ stDRes.data.author_CN }}</div>
                <div class="date">{{ $stDateChange(stDRes.data.release_time_check) }}</div>
              </div>
              <div class="marketShow" v-if="stDRes.data.symbol" @click="$goChart(stDRes.data.symbol)"
                   :style="'backgroundColor:'+(stDRes.data.symbol && parseFloat(priceData[stDRes.data.symbol].rateProfit) <0?'#edfef8':'#fff1f2')">
                <div class="marketShowLine"
                     :style="'backgroundColor:'+(stDRes.data.symbol && parseFloat(priceData[stDRes.data.symbol].rateProfit) <0?'#2eba94':'#f84242')"></div>

                <div class="symbolNameD">{{ stDRes.data.symbol_cn }}({{ stDRes.data.symbol }})</div>
                <div class="symbolArrow">
                  <svg-icon icon-class="detailArrow" style="width:5px;height:9px;"></svg-icon>
                </div>
                <div class="symbolRP">{{ priceData[stDRes.data.symbol].rateProfit }}%</div>
                <div class="symbolS">{{ priceData[stDRes.data.symbol].strike }}</div>
              </div>
              <div class="stD" v-if="stDRes.data.tp_price">


                <div class="stState" v-if="stDRes.data">
                  <div class="direction"
                       :style="stDRes.data.trading_direction_id===1?'background-color: #f84242;':'background-color: #2eba94;'">
                    {{ stDRes.data.trading_direction_id_CN }}
                    <svg-icon :icon-class="stDRes.data.trading_direction_id===1?'stUp':'stDown'"
                              style="width:6px;height:7px;padding-bottom: 3px"></svg-icon>
                  </div>

                  <div class="polSt"
                       :style="stDRes.data.policy_status===1?'color : #196ddc':stDRes.data.policy_status===2?'color:#f84242':'color:#2eba94'">
                    {{ stDRes.data.policy_status === 1 ? '持仓中' : stDRes.data.policy_status === 2 ? '已止盈' : '已止损' }}
                  </div>
                  <div :class="points<0?'diffGreen':'diffRed'">
                    {{ points }}点
                  </div>
                  <div class="timePeriod">{{ stDRes.data.time_period_id_CN }}</div>
                </div>

                <div class="priceRegion" v-if="stDRes.data">
                  <div class="priceRegionIn">
                    <div class="leftRe">
                      <div class="openPrice">
                        <span>{{ stDRes.data.open_price }}</span>
                      </div>
                      <div class="openPriceLabel">
                        <span>进场价</span>
                      </div>
                    </div>
                  </div>

                  <div class="vLine"></div>
                  <div class="rightRe" v-if="stDRes.data">
                    <div class="rightReIn">

                      <div style="height: 22px;">
                        <span class="targetPriceLabelD">目标价范围</span>
                        <span
                            class="targetPriceD">{{
                            $accSub(parseFloat(stDRes.data.tp_price), parseFloat(stDRes.data.deviation_value))
                          }}-{{
                            $accAdd(parseFloat(stDRes.data.tp_price), parseFloat(stDRes.data.deviation_value))
                          }}</span>
                      </div>
                      <div style="height: 22px;">
                        <span class="stopPriceLabelD">止损价范围</span>
                        <span
                            class="stopPriceD">{{
                            $accSub(parseFloat(stDRes.data.sl_price), parseFloat(stDRes.data.deviation_value))
                          }}-{{
                            $accAdd(parseFloat(stDRes.data.sl_price), parseFloat(stDRes.data.deviation_value))
                          }}</span>
                      </div>

                    </div>
                  </div>
                </div>


              </div>
              <div class="imgBox" v-if="stDRes.data.cover">
                <img :src="stDRes.data.cover" style="width: 100%">
              </div>
              <div style="width: 100%;height: auto" v-if="stDRes.data.strategy_data.expect_yield">
                <ul class="strategyDataList">
                  <li class="strategyDataL">
                    <span class="sDLeft">预期收益率</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.expect_yield }}%</span>
                  </li>
                  <li class="strategyDataR">
                    <span class="sDLeft">总胜率</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.win_rate }}%</span>
                  </li>
                  <li class="strategyDataL">
                    <span class="sDLeft">信号强度</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.reliability }}%</span>
                  </li>
                  <li class="strategyDataR">
                    <span class="sDLeft">作者</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.author }}</span>
                  </li>
                  <li class="strategyDataL">
                    <span class="sDLeft">计价货币</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.money_of_account_CN }}</span>
                  </li>
                  <li class="strategyDataR">
                    <span class="sDLeft">类型</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.type }}</span>
                  </li>
                  <li class="strategyDataL">
                    <span class="sDLeft">形态</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.shape_id_CN }}</span>
                  </li>
                  <li class="strategyDataR">
                    <span class="sDLeft">近10条策略胜率</span>
                    <span class="sDRight">{{ stDRes.data.strategy_data.nearly_ten_wins }}%</span>
                  </li>
                </ul>
              </div>

              <div class="blueLabel">
                <div class="blueLine"></div>
                策略描述
              </div>

              <div class="title" v-if="stDRes.data">{{ stDRes.data.title }}</div>

              <div class="description" v-if="stDRes.data">
                <div class="textCon" v-html="stDRes.data.content"></div>
              </div>


              <div class="blueLabel">
                <div class="blueLine"></div>
                收益曲线
              </div>
              <div id="charts" class="chart"></div>
              <div class="remind">
          <span>
          【风险提示】市场有风险，投资需谨慎。<br/>
          【免责声明】图表家的文章和策略资讯以及所表达意见仅作参考之用,不构成任何投资、法律、会计或税务的最终操作建议，图表家（上海向右网络科技有限公司）不就资讯中的内容对最终操作建议做出任何担保，投资者根据资讯作出的任何投资决策与图表家（上海向右网络科技有限公司）及资讯作者无关。
      </span>
              </div>

              <div class="dLine"></div>

              <div class="ad" v-for="(item,index) in adRes.data">
                <img :src="item.images" style="width: 100%;height: auto" @click="goAd(index)">
              </div>
              <div style="height: 20px"></div>


            </div>
          </div>
        </div>

      </transition>


    </div>
  </div>
</template>

<script>


import Share from "@/components/public/share";
export default {
  name: "strategyDetail",
  components: {Share},
  data() {
    return {

      stDRes: {data: {strategy_data: {}}},
      priceData: {},
      adRes: {data: {}},

    }
  },
  computed: {
    screenWidth() {
      return this.$store.state.screenWidth;
    },
    points() {
      let result = 0
      let priceNow = parseFloat(this.priceData[this.stDRes.data.symbol].strike)
      let openPrice = parseFloat(this.stDRes.data.open_price)
      let step = parseFloat(this.stDRes.data.price_per_point)
      if (isNaN(priceNow) || isNaN(openPrice) || isNaN(step)) {
        result = 0
      } else {
        if (parseInt(this.stDRes.data.trading_direction_id) === 1) {
          result = this.$math.round((priceNow - openPrice) / step)
        } else {
          result = this.$math.round((openPrice - priceNow) / step)
        }
      }
      return result
    }
  },
  methods: {
    Load(query) {
      if (query.id === undefined) {
        this.$router.push("/")
      } else {
        query = this.$encrypt(this.$genQuery(query))
        this.$get(this.$store.state.apiUrl + "/information/StrategyInfo", {qdata: query}).then(res => {
          this.stDRes = res


          if (this.stDRes.data.symbol) {
            this.connectWs([this.stDRes.data.symbol])
          } else {
            this.connectWs([])
          }


          this.chartsInit(this.stDRes.data.yield_data.yield_List)


          // this.strategyData.expectYield = this.stDRes.data.strategy_data.expect_yield

          window.scrollTo(0, 0)

        }).catch(err => {
        })
      }

    },


    chartsInit(list) {
      this.charts = this.$echarts.init(document.getElementById('charts'))
      let data = []
      for (let i = 0; i < list.length; i++) {
        let value = list[i]
        data.push({name: i, value: [i, value]})
      }

      let option = {
        xAxis: {
          minInterval: 1,
          axisLine: {
            lineStyle: {
              color: '#dedede'
            }
          },
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: '{value}',
            textStyle: {
              color: '#919bad'
            }
          },
          axisTick: {
            show: false
          },
          type: 'value'
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: '#dedede'
            }
          },
          axisLabel: {
            formatter: '{value}%',
            textStyle: {
              color: '#919bad'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#eeeeee'
            }
          }
        },
        series: [{
          data: data,
          type: 'line',
          symbol: 'none',
          itemStyle: {
            normal: {
              lineStyle: {
                width: 2, // 折线宽度
                color: '#0a6ccf'// 折线颜色
              }
            }
          }
        }],
        title: {
          text: '累计收益',
          textStyle: {
            fontSize: 14,
          }
        },
        grid: {
          right: '16px',
          bottom: '20px',

        },
      }
      this.charts.setOption(option)
      this.$store.state.watchSt = true
    },
    getFreshPrice: function () {
      if (localStorage.newPriceKey) {
        this.priceData = JSON.parse(localStorage.newPriceKey)
        this.$forceUpdate()
      }
    },
    getAd() {
      let query = this.$encrypt(this.$genQuery({evkey: 'app_article_info'}))
      this.$post(this.$store.state.apiUrl+"/ads/getad", {qdata: query}).then(res => {
        this.$forceUpdate();
        this.adRes = res

      }).catch(err => {
        console.log(err)
      })
    },
    goAd(index){
      let urlSplit = this.adRes.data[index].jumpinfo.split("=")
      let title = this.adRes.data[index].title
      let url = urlSplit[1]
      if(url){
        this.$router.push({path:'/advertisement',query:{url,title}})
      }
    }
  },
  mounted() {
    this.Load({id: this.$route.query.id, is_edit: this.$route.query.preview || ''})
    this.getFreshPrice()
    window.addEventListener('newPrice', this.getFreshPrice)

    this.getAd()
  },

  watch: {
    screenWidth() {
      if (this.$store.state.watchSt) {
        this.charts.resize()
      }
    },
    $route() {
      this.getFreshPrice()
    }
  }

}
</script>
<style lang="scss" scoped>


.background {
  background-color: #f4f6fa;
}

.mainBody {
  width: 100%;
  background-color: white;
}

.inBody {
  padding: 0 16px;
}

.strategyInfo {
  margin: 10px 0;
  height: 16px;
  padding: 3px 0;
  display: flex;
  align-items: center;
}

.authorLabel {
  font-size: 12px;
  color: #93a2b8;
}

.authorD {
  font-size: 12px;
  margin-left: 6px;
}

.date {
  font-size: 12px;
  margin-left: auto;
}

.marketShow {
  height: 36px;
  font-size: 14px;
  font-weight: bolder;
}

.marketShowLine {
  height: 2px;
  margin-bottom: 6px;
}

.symbolNameD {
  margin-left: 16px;
  margin-top: 2px;
  float: left;

}

.symbolRP {
  margin-right: 15px;
  margin-top: 2px;
  float: right;
}

.symbolS {
  margin-right: 15px;
  margin-top: 2px;
  float: right;
}

.symbolArrow {
  float: right;
  margin-right: 16px;
}

.stD {
  width: 100%;
  height: 110px;
  background-color: #f9f9f9;


}

.stState {
  width: 100%;
  height: 45px;
  display: flex;
  align-items: center;
}

.direction {
  font-size: 12px;
  color: white;
  padding: 1px 4px;
  border-radius: 3px;
  margin-left: 14px;
  height: 16px;
}

.polSt {
  float: right;
  font-size: 10px;
  border: 1px solid;
  border-radius: 3px;
  padding: 0 6px;
  margin-left: 6px;
}

.diffRed {
  float: left;
  font-size: 12px;
  padding: 1px 4px;
  border-radius: 3px;
  margin: 2px 6px;
  height: 16px;
  color: #f84242;
  background-color: #ffd8d8;
}

.diffGreen {
  float: left;
  font-size: 12px;
  padding: 1px 4px;
  border-radius: 3px;
  margin: 2px 6px;
  height: 16px;
  color: #2eba94;
  background-color: #d8fff4;
}

.timePeriod {
  margin-left: auto;
  font-size: 12px;
  color: #93a2b8;
  margin-right: 16px;
}

.priceRegion {
  width: 100%;
  height: 55px;


}

.priceRegion {
  width: 100%;
  height: 45px;
  margin-top: 5px;
}

.leftRe {
  float: left;
  width: 40%;
  height: 45px;
}

.openPrice {
  color: #f84242;
  font-size: 26px;
  font-weight: bolder;
  text-align: left;
  margin-left: 16px;

}

.openPriceLabel {
  font-size: 12px;
  text-align: left;
  margin-left: 16px;
}

.vLine {
  float: left;
  width: 1px;
  height: 45px;
  background-color: #e6e6e6;
}

.rightRe {
  float: right;
  height: 45px;

}

.rightReIn {
  margin-right: 16px;
  min-width: 170px;
}

.targetPriceLabelD {
  font-size: 12px;
  float: left;
  color: #93a2b8;
  height: 31px;
}

.targetPriceD {
  font-size: 12px;
  color: black;
  float: right;
  height: 31px;
}

.stopPriceLabelD {
  font-size: 12px;
  float: left;
  color: #93a2b8;

}

.stopPriceD {
  font-size: 12px;
  color: black;
  float: right;

}

.imgBox {
  width: 100%;
  border: 1px solid #e6e6e6;
  margin-top: 12px;
  box-sizing: border-box;
}

.strategyDataList {
  width: 100%;
  font-size: 12px;

}

.strategyDataL {
  width: 50%;
  float: left;
  margin-top: 12px;
  padding-right: 10px;
  box-sizing: border-box;
}

.strategyDataR {
  width: 50%;
  float: left;
  margin-top: 12px;
  padding-left: 10px;
  box-sizing: border-box;
}


.sDLeft {
  float: left;
  color: #585e6a;
}

.sDRight {
  float: right;
}

.blueLine {
  background-color: #1875f8;
  width: 3px;
  height: 18px;
  margin-right: 10px;
}

.blueLabel {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  color: #323440;
  font-size: 16px;
  font-weight: bolder;

}

.title {
  width: 100%;
  font-size: 16px;
  font-weight: bolder;
  text-align: left;
}

.description {
  width: 100%;
}

.textCon {
  width: 100%;
  font-size: 15px;
  /*font-family: "PingFang SC";*/
  /deep/ * {
    text-align: left;
    line-height: 25px;
    font-size: 15px !important;
    font-style: normal !important;

    img {
      height: auto !important;
      max-width: 100% !important;
      margin: 15px 0 !important;
    }
  }
}

.remind {
  text-align: left;
  font-size: 13px;
  color: #919bad;
  margin: 10px 0;
}

.chart {
  width: 100%;
  height: 60vw;
}

.fade-enter-active {
  transition: all .3s ease;
}

.fade-enter {
  opacity: 0;
}

.dLine {
  width: 100%;
  height: 1px;
  background-color: #edf0f4;
  margin: 20px 0;
}

.ad {
  width: 100%;
  height: auto;
}
</style>

